module.exports = __webpack_public_path__ + "media/images/athletes/1618-61217c5910c1aaf07e2b7fc37beb5cb4.png";